<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-text-field
      code="telephone"
      v-model="sasReconnaissanceDeFormation.numeroDeTelephone"
      :live="liveSasReconnaissanceFormation(10717)"
      is-phone-number
      optional
    ></opq-text-field>

    <opq-text-field
      code="courriel"
      v-model="sasReconnaissanceDeFormation.courriel"
      :live="liveSasReconnaissanceFormation(10718)"
      is-email
    ></opq-text-field>

    <opq-text-field
      code="site-web"
      v-model="sasReconnaissanceDeFormation.siteWeb"
      :live="liveSasReconnaissanceFormation(10719)"
      optional
    ></opq-text-field>

    <opq-catalogue
      code="modalite"
      v-model="sasReconnaissanceDeFormation.modalite"
      :live="liveSasReconnaissanceFormation(10720)"
      multiple
    ></opq-catalogue>

    <opq-catalogue
      code="langue-informations"
      v-model="sasReconnaissanceDeFormation.langueDesInformations"
      :live="liveSasReconnaissanceFormation(10721)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estFrancais"
      code="resume-fr"
      v-model="sasReconnaissanceDeFormation.resumeFR"
      :live="liveSasReconnaissanceFormation(10724)"
    ></opq-memo>

    <opq-memo
      :opq-if="estAnglais"
      code="resume-en"
      v-model="sasReconnaissanceDeFormation.resumeEN"
      :live="liveSasReconnaissanceFormation(10725)"
    ></opq-memo>

    <opq-memo
      :opq-if="estFrancais"
      code="bio-fr"
      v-model="sasReconnaissanceDeFormation.bioFormateursFR"
      :live="liveSasReconnaissanceFormation(10726)"
    ></opq-memo>

    <opq-memo
      :opq-if="estAnglais"
      code="bio-en"
      v-model="sasReconnaissanceDeFormation.bioFormateursEN"
      :live="liveSasReconnaissanceFormation(10727)"
    ></opq-memo>

    <opq-text-field
      :opq-if="estFrancais"
      code="objectif-1-fr"
      v-model="sasReconnaissanceDeFormation.objectif1FR"
      :live="liveSasReconnaissanceFormation(10728)"
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estAnglais"
      code="objectif-1-en"
      v-model="sasReconnaissanceDeFormation.objectif1EN"
      :live="liveSasReconnaissanceFormation(10729)"
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estFrancais"
      code="objectif-2-fr"
      v-model="sasReconnaissanceDeFormation.objectif2FR"
      :live="liveSasReconnaissanceFormation(10730)"
      optional
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estAnglais"
      code="objectif-2-en"
      v-model="sasReconnaissanceDeFormation.objectif2EN"
      :live="liveSasReconnaissanceFormation(10731)"
      optional
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estFrancais"
      code="objectif-3-fr"
      v-model="sasReconnaissanceDeFormation.objectif3FR"
      :live="liveSasReconnaissanceFormation(10732)"
      optional
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estAnglais"
      code="objectif-3-en"
      v-model="sasReconnaissanceDeFormation.objectif3EN"
      :live="liveSasReconnaissanceFormation(10733)"
      optional
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estFrancais"
      code="objectif-4-fr"
      v-model="sasReconnaissanceDeFormation.objectif4FR"
      :live="liveSasReconnaissanceFormation(10734)"
      optional
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estAnglais"
      code="objectif-4-en"
      v-model="sasReconnaissanceDeFormation.objectif4EN"
      :live="liveSasReconnaissanceFormation(10735)"
      optional
      :longueurMax="200"
      width="500"
    ></opq-text-field>

    <opq-memo
      :opq-if="estFrancais"
      code="prerequis-fr"
      v-model="sasReconnaissanceDeFormation.exigencesOuPrerequisALInscriptionFR"
      :live="liveSasReconnaissanceFormation(10736)"
      optional
    ></opq-memo>

    <opq-memo
      :opq-if="estAnglais"
      code="prerequis-en"
      v-model="sasReconnaissanceDeFormation.exigencesOuPrerequisALInscriptionEN"
      :live="liveSasReconnaissanceFormation(10737)"
      optional
    ></opq-memo>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasReconnaissanceDeFormation() {
      return this.sas.sasReconnaissanceDeFormation
    },

    estFrancais() {
      return this.getCatalogueCodeById(9829, this.sasReconnaissanceDeFormation.langueDesInformations) == "1" || this.estLesDeuxLangues
    },

    estAnglais() {
      return this.getCatalogueCodeById(9829, this.sasReconnaissanceDeFormation.langueDesInformations) == "2" || this.estLesDeuxLangues
    },

    estLesDeuxLangues() {
      return this.getCatalogueCodeById(9829, this.sasReconnaissanceDeFormation.langueDesInformations) == "3"
    }
  },

  methods: {
    liveSasReconnaissanceFormation(cle) {
      return { endpoint: "/sas-reconnaissance-formation/", cle: cle, fileId: this.sasReconnaissanceDeFormation.id }
    }
  }
}
</script>

<style>
</style>